import {useEffect, useRef} from 'react';
import {X, CheckCircle, XCircle} from 'lucide-react';
import {ToastProps} from '../../types';

export function Toast({message, productName, productImage, onClose, duration = 2000, type = 'success'}: ToastProps) {
    // Use ref to store the latest onClose callback to avoid re-running effect on every render
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        const timer = setTimeout(() => {
            onCloseRef.current();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    return (
        <div className="fixed bottom-4 right-4 z-[200] animate-slide-in-right">
            <div
                className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-3 max-w-sm min-w-[320px]">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gray-100">
                    <img
                        src={productImage}
                        alt={productName}
                        className="w-full h-full object-cover"
                    />
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        {type === 'error' ? (
                            <XCircle className="w-4 h-4 text-red-600 flex-shrink-0"/>
                        ) : (
                            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0"/>
                        )}
                        <p className="text-sm font-medium text-gray-900">{message}</p>
                    </div>
                    <p className="text-xs text-gray-600 truncate">{productName}</p>
                </div>

                <button
                    onClick={onClose}
                    className="flex-shrink-0 p-1 hover:bg-gray-100 rounded transition-colors"
                >
                    <X className="w-4 h-4 text-gray-500"/>
                </button>
            </div>
        </div>
    );
}
